import api from "../config/api";

export const getDistanceRate = async (source_id, destination_id) => {
  try {
    const response = await api.get(`/trip/distance/`, {
      params: { source_id, destination_id },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching distance rate:", error);
    throw error;
  }
};
